import React, {useEffect, useState} from 'react';
import {useTranslation, withTranslation} from "react-i18next";
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../../reducers";
import {getUser, getVouchers} from "../../../services/User/reducer";
import {useAuth} from "../../../services/User/auth";
import UserUtils from "../../../services/User/UserUtils";
import Money from "../../Common/Money";
import {ReactComponent as GiftSVG} from "../../../../images/icons/gift.svg";
import {ReactComponent as BogoOutlineSVG} from "../../../../images/icons/bogo-outline.svg";
import {ReactComponent as InfoSVG} from "../../../../images/icons/info.svg";
import {ReactComponent as TrophyStarSVG} from "../../../../images/icons/trophy-star.svg";
import {ReactComponent as CashbackSVG} from "../../../../images/icons/cashback-outline.svg";
import {ReactComponent as ArrowRightSVG} from "../../../../images/icons/arrow-right.svg";
import {getStoreConfigLoyalty} from "../../../services/Store/reducer";
import AppConfig from "../../../services/AppConfig";
import {ReactComponent as BackgroundCircleShapeSVG} from "../../../../images/backgrounds/background-circle-shape.svg";
import {ReactComponent as BackgroundOrnamentSVG} from "../../../../images/backgrounds/background-ornament.svg";
import LoyaltyPointsInfoModalComponent from "../../User/components/LoyaltyPointsInfoModalComponent";
import LoyaltyCashbackInfoModalComponent from "../../User/components/LoyaltyCashbackInfoModalComponent";
import LoginUserModal from "../../User/LoginUserModal";

interface OwnProps {
    onSuccess: () => void;
    onHide: () => void;
    setPage: (page?: string) => void;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function UserMainDrawer({user, config_loyalty, onHide, setPage, vouchers}: Props) {
    const [qrcodeBase64, setQrcodeBase64] = useState<undefined | string>(undefined);
    const [loginModal, setLoginModal] = useState(false);
    const [loyaltyPointsInfoModal, setLoyaltyPointsInfoModal] = useState(false);
    const [loyaltyCashbackInfoModal, setLoyaltyCashbackInfoModal] = useState(false);
    const auth = useAuth();
    const {t} = useTranslation();

    useEffect(() => {
        if (!user) {
            return;
        }
        const fetchQrcode = async () => {
            if (!UserUtils.isLoyaltyQrcodeEnabled(config_loyalty)) return;

            if (user.qrcode) {
                setQrcodeBase64(user.qrcode);
            } else {
                const response = await auth.qrcode();
                if (response) {
                    setQrcodeBase64(response);
                }
            }
        };

        fetchQrcode();
    }, [user?.id]);

    const handleLogout = async () => {
        try {
            await auth.logout();
            onHide();
        } catch (err) {
            console.log(err);
        }
    }
    return (
            <div>
                <div className={"user-info mb-5"}>
                     <BackgroundCircleShapeSVG className="background-shape" />
                    {AppConfig.isDarkMode() && <BackgroundOrnamentSVG className="ornament-shape" />}
                    <div className={"user-info-header"}>
                        <button onClick={onHide} className={"btn-close btn-close-white ms-auto me-2"} data-bs-dismiss="modal"
                                aria-label="Close"/>
                    </div>
                    <div className={"user-info-body"}>
                        {loyaltyPointsInfoModal && (
                            <LoyaltyPointsInfoModalComponent config_loyalty={config_loyalty}
                                                             onHide={() => setLoyaltyPointsInfoModal(false)}
                                                             onClick={() => {
                                                                 setLoyaltyPointsInfoModal(false);
                                                                 setPage("vouchers");
                                                             }}/>
                        )}
                        {loyaltyCashbackInfoModal && (
                            <LoyaltyCashbackInfoModalComponent config_loyalty={config_loyalty}
                                                               onHide={() => setLoyaltyCashbackInfoModal(false)}/>
                        )}
                        {!user.verified && (
                            <>
                                <div className={"alert alert-warning"}>
                                    {t("constraints.internal.account_not_verified")}, <a href={"#"}
                                                                                         onClick={() => setLoginModal(true)}>
                                    {t("modules.user.action.click_to_verify_account.title")}</a>
                                </div>
                                {loginModal && (
                                    <LoginUserModal onHide={() => setLoginModal(false)} show/>
                                )}
                            </>
                        )}
                        <h5 className={`${UserUtils.isLoyaltyQrcodeEnabled(config_loyalty) && qrcodeBase64 ? "mb-3" : "mb-4"}`}>
                            {`${t("modules.user.field.hello.title")}, ${user.name}!`}
                        </h5>
                        {UserUtils.isLoyaltyQrcodeEnabled(config_loyalty) && qrcodeBase64 && (
                                        <>
                                            <div className={"user-info-qrcode"}>
                                                <img src={`data:image/png;base64,${qrcodeBase64}`} alt="QR Code"/>
                                            </div>
                                            <p className={"user-info-qrcode-text"}>
                                                {t("modules.user.field.scan_code_at_restaurant.title")}

                                            </p>
                                        </>
                        )}
                        {(UserUtils.isAnyLoyaltyProgramEnabled(config_loyalty)) && (
                            <div className={"user-info-boxes nav nav-pills nav-fill flex-column w-100"}>
                                {UserUtils.isLoyaltyPointsEnabled(config_loyalty) && (
                                        <li className="nav-item">
                                            <button onClick={() => setLoyaltyPointsInfoModal(true)}
                                                    className="nav-link">
                                                <TrophyStarSVG/>
                                                <div>
                                                    {t("modules.user.field.points.title")}
                                                    {user?.points  ? (
                                                        <strong>
                                                            {user?.points}
                                                        </strong>
                                                    ) : (
                                                        <small>{t("modules.user.field.lack.title")}</small>
                                                    )}
                                                </div>
                                                <InfoSVG/>
                                            </button>
                                        </li>
                                )}
                                {UserUtils.isLoyaltyGroupsEnabled(config_loyalty) && user.group_name && (
                                    <li className="nav-item">
                                        <div className="nav-link">
                                            <BogoOutlineSVG/>
                                            <div>
                                                {t("modules.user.field.your_group.title")}
                                                <strong>{user.group_name}</strong>
                                            </div>
                                        </div>
                                    </li>
                                )}
                                {UserUtils.isLoyaltyCashbackEnabled(config_loyalty) && (
                                    <li className="nav-item">
                                        <button onClick={() => setLoyaltyCashbackInfoModal(true)} className="nav-link">
                                            <CashbackSVG/>
                                                <div>
                                                    {t("modules.user.field.cashback.title")}
                                                    {user.promotional_credits ? (
                                                        <strong>
                                                            <Money
                                                                value={user.promotional_credits}/>
                                                        </strong>
                                                    ) : (
                                                        <small>{t("modules.user.field.lack.title")}</small>
                                                    )}
                                                </div>
                                            <InfoSVG/>
                                            </button>
                                        </li>
                                )}
                                {UserUtils.isLoyaltyVoucherEnabled(config_loyalty) && (
                                    <li className="nav-item">
                                        <button onClick={() => setPage("vouchers")}
                                                className="nav-link">
                                            <GiftSVG/>
                                            <div>
                                                {t("modules.user.field.vouchers.title")}
                                                <strong>{vouchers ? vouchers.length : 0} {t("modules.user.field.available.title")}</strong>
                                            </div>
                                            <ArrowRightSVG/>
                                        </button>
                                    </li>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                <div className={"user-menu"}>
                    <h5>
                        {t("modules.user.field.account.title")}
                    </h5>
                    <div className={"nav nav-pills nav-fill flex-column"}>

                        <li className="nav-item">
                            <button onClick={() => setPage("edit")} className="nav-link"
                                    aria-current="page">
                                {t("modules.user.field.data.title")}
                                <ArrowRightSVG/>
                            </button>
                        </li>
                        <li className="nav-item">
                            <button onClick={() => setPage("delete")} className="nav-link"
                                    aria-current="page">
                                {t("modules.user.action.remove_account.title")}
                                <ArrowRightSVG/>
                            </button>
                        </li>
                        <li className="nav-item">

                            <a href={"#"} onClick={(e) => {
                                e.preventDefault();
                                handleLogout()
                            }} className="nav-link"
                               aria-current="page">
                                {t("modules.user.action.logout.title")}
                                <ArrowRightSVG/>
                            </a>
                        </li>
                    </div>
                </div>
            </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    user: getUser(state.user),
    config_loyalty: getStoreConfigLoyalty(state.config),
    vouchers: getVouchers(state.user)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(UserMainDrawer));
